import React, { useState } from 'react'
import * as XLSX from 'xlsx';
import { Card, CardBody, Col, Input, Label, Row, Button } from 'reactstrap'
import { Chart } from 'primereact/chart';
import { useReportNonConforming } from '../../../hooks/Pbi/useReportNonConforming';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const IndexDashboardNonConforming = () => {



	const {
		filtersBalance,
		totalMovements,
		listOfClients,
		fieldChartData,
		fieldModificationOptions,
		doughnutLabelsPlugin,
		doughnutCenterPlugin,
		userChartData,
		userModificationOptions,
		userValuesPlugin,
		setFiltersBalance,
		loadingBalance,
		handleGetNonConforming,

		exportToExcelNonConforming,
		downloading,
		listConforming,
		totalOrder



	} = useReportNonConforming();



	const modificationRate = totalOrder > 0 ? ((totalMovements / totalOrder) * 100).toFixed(1) : 0;


	const [globalFilterConforming, setGlobalFilterConforming] = useState("");

	const headerConforming = (
		<div
			className="d-flex justify-content-between align-items-center pt-2 pb-2"
			style={{
				gap: "12px",
				flexWrap: "wrap"
			}}
		>
			<span
				style={{
					fontWeight: 600,
					color: "#042c54",
					fontSize: "14px"
				}}
			>
				Detalle de modificaciones
			</span>

			<span className="p-input-icon-left">

				<Input
					type="text"
					value={globalFilterConforming}
					onChange={(e) =>
						setGlobalFilterConforming(e.target.value)
					}
					placeholder="Buscar..."
					style={{
						width: "260px",
						height: "36px",
						borderRadius: "10px",
						fontSize: "13px"
					}}
				/>
			</span>
		</div>
	);


	const getConformingRowClass = (rowData) => {

		const modificationUser =
			Number(rowData?.id_user);

		const workOrderUser =
			Number(rowData?.id_user_work_order);

		if (
			modificationUser > 0 &&
			workOrderUser > 0 &&
			modificationUser !== workOrderUser
		) {
			return "non-conforming-different-user-row";
		}

		return "";
	};



	return (
		<div className='container-global-zoom-Overdue' >
			<div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
				<Card style={{
					marginBottom: '15px',
					background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
					border: 'none',
					boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
				}}>
					<CardBody style={{ padding: '18px 25px' }}>
						<div className="d-flex align-items-center justify-content-between">
							<div className="d-flex align-items-center">
								<div style={{
									width: '55px',
									height: '55px',
									borderRadius: '12px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginRight: '15px'
								}}>
									<img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/Non-conforming.svg")} style={{ width: "120px", height: "120px", filter: "invert(1)" }} />
								</div>
								<div>
									<div style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										flexWrap: 'wrap',
										marginBottom: '10px'
									}}>

										{/* TÍTULO */}
										<h4
											className="mb-1"
											style={{
												color: '#fff',
												fontWeight: 700,
												fontSize: '20px',
												margin: 0
											}}
										>
											Resumen de Muestas no conformes
										</h4>
									</div>
									<small>
										<div style={{
											display: 'flex',
											alignItems: 'center',
											gap: '10px',
											background: 'rgba(255,255,255,0.08)',
											padding: '6px 12px',
											borderRadius: '12px',
											color: '#fff',
											fontSize: '12px',
											fontWeight: 600,
											flexWrap: 'wrap'
										}}>

											<i className="fa fa-calendar" />

											Periodo:

											<span style={{ fontWeight: 700 }}>
												{filtersBalance.dateStart || '---'}
											</span>

											<span>-</span>

											<span style={{ fontWeight: 700 }}>
												{filtersBalance.dateEnd || '---'}
											</span>

											{filtersBalance.clientId && (
												<>
													<span style={{ opacity: 0.6 }}>|</span>

													<i className="fa fa-building" />

													<span style={{ fontWeight: 600 }}>
														{
															listOfClients?.find(
																c => c.id === filtersBalance.clientId
															)?.name
														}
													</span>
												</>
											)}



										</div>
									</small>
								</div>
							</div>

						</div>
					</CardBody>
				</Card>

				<Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
					<Col sm="12" className='pt-3'>
						<Row>
							<Col sm="12">
								<div
									style={{
										marginTop: '1px',
									}}>
									<Col sm="12" className='p-l-0 p-r-0' >

										{
											// * DASHBOARD CONFIGURATION INDICADORES
										}

										<div className="row mb-3" >
											<div className="col-md-3">

												<div
													//className="card "
													style={{
														padding: "12px 14px"
													}}
												>




													{/* FECHAS */}
													<div
														style={{
															display: "flex",
															gap: "8px",
															width: "100%"
														}}
														className='pt-2'
													>

														{/* FECHA INICIO */}
														<div
															style={{
																flex: 1,
																minWidth: 0
															}}
														>

															<Label
																className="mb-1"
																style={{
																	fontSize: "16px",
																	fontWeight: 600,
																	color: "#64748b"
																}}
															>
																Fecha inicio
															</Label>

															<Input
																type="date"
																value={filtersBalance.dateStart}
																onChange={(e) =>
																	setFiltersBalance(prev => ({
																		...prev,
																		dateStart: e.target.value
																	}))
																}
																disabled={loadingBalance}
																style={{
																	width: "100%",
																	height: "34px",
																	borderRadius: "8px",
																	fontSize: "14px",
																	padding: "4px 6px",
																	border: "1px solid #dbe5ee"
																}}
															/>

														</div>


														{/* FECHA FIN */}
														<div
															style={{
																flex: 1,
																minWidth: 0
															}}
														>

															<Label
																className="mb-1"
																style={{
																	fontSize: "16px",
																	fontWeight: 600,
																	color: "#64748b"
																}}
															>
																Fecha fin
															</Label>

															<Input
																type="date"
																value={filtersBalance.dateEnd}
																onChange={(e) =>
																	setFiltersBalance(prev => ({
																		...prev,
																		dateEnd: e.target.value
																	}))
																}
																disabled={loadingBalance}
																style={{
																	width: "100%",
																	height: "34px",
																	borderRadius: "8px",
																	fontSize: "14px",
																	padding: "4px 6px",
																	border: "1px solid #dbe5ee"
																}}
															/>

														</div>

													</div>


													{/* ACCIONES */}
													<div
														style={{
															display: "flex",
															gap: "8px",
															marginTop: "9px"
														}}
													>

														<Button
															onClick={handleGetNonConforming}
															disabled={loadingBalance}
															style={{
																flex: 1,
																height: "32px",
																borderRadius: "8px",
																padding: "0 10px",
																fontSize: "12px",
																fontWeight: 600,
																border: "none",
																background:
																	"linear-gradient(135deg, #1d5b83, #0d3b59)"
															}}
														>

															{loadingBalance
																? "Buscando..."
																: "Buscar"
															}
														</Button>


														<Button
															color="success"
															disabled={
																listConforming?.length === 0 ||
																loadingBalance ||
																downloading
															}
															onClick={() =>
																exportToExcelNonConforming(
																	listConforming
																)
															}
															style={{
																flex: 1,
																height: "32px",
																borderRadius: "8px",
																padding: "0 10px",
																fontSize: "12px",
																fontWeight: 600
															}}
														>
															<i className="fa fa-file-excel-o mr-1"></i>

															{downloading
																? "..."
																: "Excel"
															}
														</Button>

													</div>

												</div>

											</div>
											<div className="col-md-3">
												<div className="card dashboard-card-overduel">
													<div className="d-flex justify-content-between">
														<span className="card-title-overduel">N° de modificaciones</span>

														<span className="trend-overduel down-overduel">
															<i style={{ color: "#0c8dd5" }} className="fa fa-pencil f-28  f-28"></i>
														</span>
													</div>
													<h2 className="card-value-overduel">
														{totalMovements}
													</h2>

													<div className="card-sub-overduel">Modificaciones</div>
													<div className="sparkline-overduel orange-overduel"></div>

												</div>
											</div>
											{
												// *
											}

											<div className="col-md-3">
												<div className="card dashboard-card-overduel">

													<div className="d-flex justify-content-between align-items-start">
														<span className="card-title-overduel ">N° Total de ordenes</span>

														<span className="trend-overduel up-overduel">
															<i className="icon-bar-chart-alt f-30"></i>
														</span>
													</div>

													<h2 className="card-value-overduel text-primary">
														{totalOrder}
													</h2>

													<div className="card-sub-overduel">Admisiones</div>

													<div className="sparkline-overduel"></div>

												</div>
											</div>

											{
												// *
											}
											<div className="col-md-3">
												{/* <div className={`card dashboard-card-overduel ${0 > 0 ? 'card-success-overduel' : ''
													}`}> */}
												<div className={`card dashboard-card-overduel card-success-overduel`}>

													<div className="d-flex justify-content-between">
														<span className="card-title-overduel">Porcentaje</span>

														<span className="trend-overduel">
															<i className="fa fa-area-chart f-30"></i>
														</span>
													</div>

													<h2 className="card-value-overduel text-success">
														%{modificationRate}
													</h2>

													<div className="card-sub-overduel">Porciento</div>
													<div className="sparkline-overduel green-overduel"></div>

												</div>
											</div>



										</div>
									</Col>



									{
										// * new table
									}
									<Col sm="12" className='pb-5' >
										<Row>
											<Col sm="6">
												{
													fieldChartData.labels.length > 0 ? (

														<div className="non-conforming-chart-card">

															<div className="non-conforming-chart-header">

																<div className="non-conforming-chart-icon">
																	<i className="fa fa-pie-chart f-24 "></i>
																</div>

																<div>
																	<h6>
																		Campos con más modificaciones
																	</h6>
																</div>

															</div>

															<div className="non-conforming-donut-content">


																<Chart
																	type="doughnut"
																	data={fieldChartData}
																	options={fieldModificationOptions}
																	plugins={[
																		doughnutLabelsPlugin,
																		doughnutCenterPlugin
																	]}
																/>

															</div>

														</div>

													) : (

														<div className="non-conforming-chart-empty">
															No hay modificaciones en este periodo
														</div>
													)
												}

											</Col>
											<Col sm="6">
												<div className="non-conforming-user-chart-card">

													<div className="non-conforming-chart-header">

														<div className="non-conforming-user-chart-icon">

															<i className="fa fa-users"></i>

														</div>

														<div>

															<h6>
																Usuarios con más modificaciones
															</h6>



														</div>

													</div>



													{
														userChartData.labels.length > 0 ? (

															<div className="non-conforming-user-chart-content">

																<Chart
																	type="bar"
																	data={userChartData}
																	options={
																		userModificationOptions
																	}
																	plugins={[
																		userValuesPlugin
																	]}
																/>

															</div>

														) : (

															<div className="non-conforming-chart-empty">

																No hay información de usuarios

															</div>
														)
													}

												</div>
											</Col>
										</Row>

									</Col>

								</div>
							</Col>



							<Col sm="12" className='pl-0 pr-0 mt-5' >
								<h5 className="mb-3">MODIFICACIÓN DE DATOS DEMÓGRAFICOS Y GESTIÓN</h5>
								{
									// * FILTER CONFIGURATION
								}

								<Col sm="12" className='pl-4 pr-4' >
									<DataTable
										className="data-table"
										value={listConforming}
										paginator
										rows={10}
										rowsPerPageOptions={[10, 20, 30, 50, 100, 200]}
										rowClassName={getConformingRowClass}
										emptyMessage={
											<div className="text-center">
												<img
													src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
													style={{ width: "25%" }}
													alt="Sin resultados"
												/>

												<br />

												<p
													className="badge badge-light-primary mt-2"
													style={{ fontSize: "10px" }}
												>
													No se encontraron modificaciones.
												</p>
											</div>
										}
										loading={loadingBalance}
										loadingIcon="pi pi-spin pi-spinner"
										globalFilter={globalFilterConforming}
										globalFilterFields={[
											"site",
											"field_name",
											"original_information",
											"updated_information",
											"name_user",
											"created_information"
										]}
										header={headerConforming}

									>

										<Column
											header="#"
											body={(rowData, { rowIndex }) => rowIndex + 1}
											style={{
												textAlign: "center",
												fontSize: "14px",
												width: "5%"
											}}
											headerStyle={{
												backgroundColor: "#1d5b83",
												color: "#fff",
												fontWeight: "bold",
												fontSize: "14px",
												padding: "8px"
											}}
										/>



										<Column
											field="user_work_order"
											header="Usuario de venta"
											sortable
											headerStyle={{
												backgroundColor: "#1d5b83",
												color: "#fff",
												fontWeight: "bold",
												fontSize: "14px",
												padding: "8px"
											}}
											style={{
												fontSize: "14px",
												textAlign: "center",
												width: "12%"
											}}
										/>


										<Column
											field="site"
											header="Sitio"
											sortable
											headerStyle={{
												backgroundColor: "#1d5b83",
												color: "#fff",
												fontWeight: "bold",
												fontSize: "14px",
												padding: "8px"
											}}
											style={{
												fontSize: "14px",
												textAlign: "center",
												width: "12%"
											}}
										/>


										<Column
											field="field_name"
											header="Campo modificado"
											sortable
											headerStyle={{
												backgroundColor: "#1d5b83",
												color: "#fff",
												fontWeight: "bold",
												fontSize: "14px",
												padding: "8px"
											}}
											style={{
												fontSize: "14px",
												textAlign: "center",
												width: "14%"
											}}
										/>


										<Column
											field="original_information"
											header="Información anterior"
											sortable
											headerStyle={{
												backgroundColor: "#1d5b83",
												color: "#fff",
												fontWeight: "bold",
												fontSize: "14px",
												padding: "8px"
											}}
											style={{
												fontSize: "14px",
												textAlign: "center",
												width: "16%"
											}}
											body={(rowData) => (
												<span
													style={{
														//color: "#dc3545",
														fontWeight: 600
													}}
												>
													{rowData?.original_information ?? ""}
												</span>
											)}
										/>


										<Column
											field="updated_information"
											header="Información nueva"
											sortable
											headerStyle={{
												backgroundColor: "#1d5b83",
												color: "#fff",
												fontWeight: "bold",
												fontSize: "14px",
												padding: "8px"
											}}
											style={{
												fontSize: "14px",
												textAlign: "center",
												width: "16%"
											}}
											body={(rowData) => (
												<span
													style={{
														//color: "#198754",
														fontWeight: 600
													}}
												>
													{rowData?.updated_information ?? ""}
												</span>
											)}
										/>

										<Column
											field="name_user"
											header="Usuario"
											sortable
											headerStyle={{
												backgroundColor: "#1d5b83",
												color: "#fff",
												fontWeight: "bold",
												fontSize: "14px",
												padding: "8px"
											}}
											style={{
												fontSize: "14px",
												textAlign: "center",
												width: "18%"
											}}
										/>


										<Column
											field="created_information"
											header="Fecha de modificación"
											sortable
											headerStyle={{
												backgroundColor: "#1d5b83",
												color: "#fff",
												fontWeight: "bold",
												fontSize: "14px",
												padding: "8px"
											}}
											style={{
												fontSize: "14px",
												textAlign: "center",
												width: "14%"
											}}
										/>

									</DataTable>
								</Col>


							</Col>

						</Row>

					</Col>
				</Card>
			</div >
		</div >
	)
}


